import React from 'react';

/** Silvr's "S" mark (Paula's silvr-logo.svg). It takes the text colour, so the same mark is dark on
 *  the gold chip and gold in the dark panel's header. */
const SilvrMark: React.FC<{ size?: number; className?: string }> = ({ size = 14, className }) => (
  <svg className={className} width={(size * 15) / 24} height={size} viewBox="0 0 15 24" fill="none" aria-hidden="true">
    <path
      d="M4.08662 10.1073L4.10985 13.934C4.12103 15.7757 2.98661 17.2894 1.11656 17.3007L0.716604 17.3031C0.318428 17.3056 -0.0024004 17.6299 1.3533e-05 18.0275L0.0319259 23.2844C0.0343398 23.682 0.359082 24.0024 0.757258 24L1.15721 23.9976C6.79165 23.9634 10.9439 19.4655 10.9102 13.9167L10.8868 10.066C10.8756 8.22437 12.01 6.71065 13.8801 6.6993L14.2834 6.69685C14.6816 6.69444 15.0024 6.37013 15 5.97249L14.9681 0.715633C14.9657 0.317992 14.6409 -0.00240181 14.2427 1.35675e-05L13.8394 0.00246032C8.205 0.0366395 4.05293 4.55844 4.08662 10.1073Z"
      fill="currentColor"
    />
  </svg>
);

export default SilvrMark;
